const isConfigValid = (options) => {
  const {
    props: {
      adSettings: {
        numberOfWordsBetweenInlineDesktopAds,
        numberOfWordsForFirstInjectionDesktop,
        minNumOfWordsAfterLastInlineAdDesktop,
      },
    },
  } = options;

  if ((!numberOfWordsBetweenInlineDesktopAds && numberOfWordsBetweenInlineDesktopAds !== 0)
  || (!numberOfWordsForFirstInjectionDesktop && numberOfWordsForFirstInjectionDesktop !== 0)
  || (!minNumOfWordsAfterLastInlineAdDesktop && minNumOfWordsAfterLastInlineAdDesktop !== 0)) return false;

  return true;
};

export default isConfigValid;
